import { render, staticRenderFns } from "./ReleaseNoteListDialog.vue?vue&type=template&id=06c05d00"
import script from "./ReleaseNoteListDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports